import Head from "next/head";
import Script from "next/script";

// GTM 容器 ID。同 APP_KEY：挪到环境变量只是去掉源码硬编码，
// 它按 GTM 设计必须出现在页面上，无法不公开。CI 未注入时回落原值。
const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || "GTM-NZV6HHC";
import { useTranslation } from "next-i18next";

// favicon 统一在 pages/_document.tsx 里声明，这里不要再插一份：
// 之前用的 ?v=${Date.now()} 在服务端和客户端取值不同，next/head 会在 hydrate 时
// 把 SSR 那个 link 先删后加，空档期浏览器会回落去请求根目录 /favicon.ico 报 404，
// 而且 href 每次都变，favicon 永远命中不了缓存。
const SEO = ({ title }: { title: string | undefined }) => {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <meta name="description" content={t("common.seo_description")} />
        <meta name="keywords" content={t("common.seo_keywords")} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
        <title>{title || t("common.seo_title")}</title>
      </Head>
      {/* 用 Script 加载 Google Tag Manager */}
      <Script
        id="google-tag-manager"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`,
        }}
      />
    </>
  );
};

export default SEO;
